import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service'
import { ApiService } from '@app/utility/api.service'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { NotiService } from '@app/noti.service';
import { Router } from '@angular/router';

declare var Captcha: any
declare var $: any
@Component({
  selector: 'app-contact-dpa',
  templateUrl: './contact-dpa.component.html',
  styleUrls: ['./contact-dpa.component.scss']
})
export class ContactDpaComponent implements OnInit {
  captcha: any
  caseTypeList: any
  caseSubTypeList: any
  caseSubTypeDetailList: any

  caseStatusList: any
  dpa_casestatusid = ""
  caseChannelList: any
  dpa_casechannelid = ""

  subTypeTmpList: any
  subTypeDetailTmpList: any

  isComplain = false

  form: FormGroup

  combinedAddressList: any
  combinedAddressListEn: any

  submitted = false
  captchaMatch = false

  cookieData: any
  contactData: any
  
  lang = "th"

  menuEnabled = false

  private notiSubscription: Subscription;

  constructor(
    private fb: FormBuilder,
    private util: UtilService,
    private apiService: ApiService,
    private notiService: NotiService,
    private router: Router
  ) {
    this.form = this.fb.group({
      contactid: "",
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      dpa_idcard: ['', this.idCardValidator],
      telephone1: ['', Validators.required],
      emailaddress1: ['', this.emailValidator],
      dpa_contact_homeno: '',
      dpa_contact_moo: "",
      dpa_contact_street: "",
      dpa_contact_subdistict: "",
      dpa_contact_distict: "",
      dpa_contact_province: "",
      dpa_contact_postcode: "",

      dpa_contact_subdistictname: "",
      dpa_contact_distictname: "",
      dpa_contact_provincname: "",
      dpa_contact_postcodename: "",

      incidentid: "",
      customerid: "",
      dpa_casetypeid: ['', Validators.required],
      dpa_casesubtypeid: ['', Validators.required],
      dpa_casesubtypedetailid: ['', Validators.required],
      dpa_casestatusid: '',
      dpa_casechannelid: '',
      description: ['', Validators.required],
      IdCard: ''
    });
  }

  ngOnDestroy() {
    if(this.notiSubscription){
      this.notiSubscription.unsubscribe();
    }
  }

  async ngOnInit() {
    const thisTs = this
    this.util.ShowWaiting(true)

    let config: any = await this.apiService.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    let isCrisis: any 
    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      isCrisis = true
    }
    else {
      isCrisis = false
    }5

    let menuList:any = await this.apiService.get("master", "customerPortalMenuSetting")
    let thisMenu: any = this.util.getMenuObj(menuList, "02", isCrisis)
    if(!thisMenu.show){
      this.util.ShowWaiting(false)
      setTimeout(() => {
        this.router.navigate(["mainmenu/index"])
      }, 500);
      return
    }
    else{
      this.menuEnabled = true
    }

    // let tmpLang = this.util.GetCurrentLang()
    // this.lang = tmpLang.substring(0,2)
    // this.util.SetLanguage(tmpLang)

    this.util.InitValidation()
    this.captcha = new Captcha($('#canvas'), {
      length: 6
    });

    if(this.lang == "th"){
      $(".select2-en").hide()
      $(".select2-th").show()
    }
    else{
      $(".select2-th").hide()
      $(".select2-en").show()
    }

    this.notiSubscription = this.notiService.message.subscribe(_lang => {
      this.lang = _lang
      if(this.lang == "th"){
        $(".select2-en").hide()
        $(".select2-th").show()
      }
      else{
        $(".select2-th").hide()
        $(".select2-en").show()
      }

      if(this.contactData != null && this.contactData.length > 0){
        $(".select2").val(this.contactData[0].dpa_contact_subdistict + "|" + this.contactData[0].dpa_contact_distict + "|" + this.contactData[0].dpa_contact_province + "|" + this.contactData[0].dpa_contact_postcode + "|" + this.contactData[0].dpa_contact_country).trigger('change')
      }
      //this.bindAddress(this.lang)
    });

    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    if(this.cookieData == null){
      this.cookieData = {}
    }

    function matchCustom(params: any, data: any) {
      if ($.trim(params.term) === '') {
        return data;
      }
      if (typeof data.text === 'undefined') {
        return null;
      }

      if (params.term.length > 1) {
        let cris = params.term.split(" ")
        let found = true
        for (var i = 0; i < cris.length; i++) {
          if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
            found = false;
            return null
          }
        }
        if (found) {
          return data;
        }
      }
      return null;
    }

    $('.select2th').select2({
      matcher: matchCustom,
      placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
    });

    $('.select2en').select2({
      matcher: matchCustom,
      placeholder: "Please select your address."
    });

    $(".select2").on("change", function (e: any) {
      thisTs.addressChange(e.target.value)
    })

    this.initDropdown()

  }

  async initDropdown() {

    if(this.cookieData.contactid != null && this.cookieData.contactid != ""){
      Observable.forkJoin(
        this.apiService.get("master", "caseType"),
        this.apiService.get("master", "caseSubType"),
        this.apiService.get("master", "caseSubTypeDetail"),
        this.apiService.get("master", "caseStatus"),
        this.apiService.get("master", "caseChannel"),
        this.apiService.getMasterAddress(),
        this.apiService.get("crmservice", "contact", "contactid=" + this.cookieData.contactid)
      ).subscribe(
        data => {
          this.caseTypeList = data[0]
          this.subTypeTmpList = data[1]
          this.subTypeDetailTmpList = data[2]
          this.caseStatusList = data[3]
          this.caseChannelList = data[4]
          this.combinedAddressList = data[5]
          this.contactData = data[6]

          this.setAddressEn()

          if(this.contactData != null && this.contactData.length > 0){
            this.mapDataToForm(this.contactData[0])
            $(".select2").val(this.contactData[0].dpa_contact_subdistict + "|" + this.contactData[0].dpa_contact_distict + "|" + this.contactData[0].dpa_contact_province + "|" + this.contactData[0].dpa_contact_postcode + "|" + this.contactData[0].dpa_contact_country).trigger('change')
          }
          
          this.util.ShowWaiting(false)
        },
        err => console.error(err)
      );
      
    }
    else{
      Observable.forkJoin(
        this.apiService.get("master", "caseType"),
        this.apiService.get("master", "caseSubType"),
        this.apiService.get("master", "caseSubTypeDetail"),
        this.apiService.get("master", "caseStatus"),
        this.apiService.get("master", "caseChannel"),
        this.apiService.getMasterAddress()
      ).subscribe(
        data => {
  
          this.util.ShowWaiting(false)
  
          this.caseTypeList = data[0]
          this.subTypeTmpList = data[1]
          this.subTypeDetailTmpList = data[2]
          this.caseStatusList = data[3]
          this.caseChannelList = data[4]
          this.combinedAddressList = data[5]
          this.setAddressEn()
        },
        err => console.error(err)
      );
    }
  }

  setAddressEn(){
    if(this.combinedAddressList != null && this.combinedAddressList.length > 0){
      this.combinedAddressListEn = this.combinedAddressList.slice().sort(function(a: any, b: any) {
        if ( a.text_eng < b.text_eng ){
          return -1;
        }
        if ( a.text_eng > b.text_eng ){
          return 1;
        }
        return 0;
      });
    }
  }

  addressChange(value: any) {
    let selected = this.combinedAddressList.filter((a: any) => a.id == value)
    if (selected != null && selected.length > 0) {
      let values = selected[0].id.split("|")
      let texts: any 
      if(this.lang == "th"){
        texts = selected[0].text.split(" | ")
      }
      else{
        texts = selected[0].text_eng.split(" | ")
      }

      this.formControl["dpa_contact_subdistict"].setValue(values[0])
      this.formControl["dpa_contact_distict"].setValue(values[1])
      this.formControl["dpa_contact_province"].setValue(values[2])
      this.formControl["dpa_contact_postcode"].setValue(values[3])

      this.formControl["dpa_contact_subdistictname"].setValue(texts[0])
      this.formControl["dpa_contact_distictname"].setValue(texts[1])
      this.formControl["dpa_contact_provincname"].setValue(texts[2])
      this.formControl["dpa_contact_postcodename"].setValue(texts[3])
    }
    else {
      this.formControl["dpa_contact_subdistict"].setValue("")
      this.formControl["dpa_contact_distict"].setValue("")
      this.formControl["dpa_contact_province"].setValue("")
      this.formControl["dpa_contact_postcode"].setValue("")

      this.formControl["dpa_contact_subdistictname"].setValue("")
      this.formControl["dpa_contact_distictname"].setValue("")
      this.formControl["dpa_contact_provincname"].setValue("")
      this.formControl["dpa_contact_postcodename"].setValue("")
    }
  }

  refreshCaptcha() {
    this.captcha.refresh();
  }

  isValidCaptcha(): boolean {
    //var a = this.captcha.getCode()
    this.captchaMatch = this.captcha.valid($('input[name="code"]').val());
    return this.captchaMatch
  }

  clear() {
    this.form.reset()
    this.formControl["dpa_contact_subdistictname"].setValue("")
    this.formControl["dpa_contact_distictname"].setValue("")
    this.formControl["dpa_contact_provincname"].setValue("")
    this.formControl["dpa_contact_postcodename"].setValue("")
    this.caseSubTypeList = []
    this.caseSubTypeDetailList = []
    $('input[name="code"]').val("")
    try {

      $(".select2").val("").trigger("change")
    }
    catch (e) {

    }
    this.refreshCaptcha()
    this.submitted = false
  }

  emailValidator(control: any) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  get formControl() {
    return this.form.controls;
  }

  get email() {
    return this.form.value.emailaddress1.trim()
  }


  onCaseTypeChange() {
    let selectedCase = this.caseTypeList.filter((c: any) => {
      return c.dpa_casetypeid == this.form.get("dpa_casetypeid").value
    })
    if (selectedCase != null && selectedCase.length > 0) {
      this.isComplain = selectedCase[0].dpa_name == "ร้องเรียน"
    }
    else {
      this.isComplain = false
    }

    this.caseSubTypeList = this.subTypeTmpList.filter(
      (subType: any) => subType.dpa_casetypeid === this.form.get("dpa_casetypeid").value)
    this.form.get("dpa_casesubtypeid").setValue("")

    this.onCaseSubTypeChange()
  }

  onCaseSubTypeChange() {
    this.caseSubTypeDetailList = this.subTypeDetailTmpList.filter(
      (s: any) => s.dpa_casesubtypeid === this.form.get("dpa_casesubtypeid").value)
    this.form.get("dpa_casesubtypedetailid").setValue("")
  }

  async sendToDPA() {
    this.submitted = true
    this.isValidCaptcha()
    if (this.form.valid && this.captchaMatch && this.isComplainFilled()) {

      this.util.ShowWaiting(true)

      // let customerId = await this.createContact()
      
      // if(customerId == null){
      //   this.util.ShowWaiting(false)
      //   this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่")
      //   return
      // }

      let selectedSubTypeDetail: any = this.caseSubTypeDetailList.filter((f: any) => {
        return f.dpa_casesubtypedetailid == this.formControl["dpa_casesubtypedetailid"].value
      })

      let channel = this.caseChannelList.filter((ch: any) => {
        return ch.dpa_code == "02"
      })

      if (selectedSubTypeDetail[0].dpa_issendemail) {

        let sendLogReq = {
          dpa_name: selectedSubTypeDetail[0].dpa_emailaddress
        }
        let sendLogRes: any = await this.apiService.post("crmservice", "logSendEmail", sendLogReq)

        if(this.util.isSuccessResponse(sendLogRes)){
          let req = {
            //contactid: customerId,
            dpa_name: "แจ้งเรื่องร้องเรียน",
            dpa_description: this.formControl["description"].value,
            dpa_emailaddress: selectedSubTypeDetail[0].dpa_emailaddress,
            template: "",
            dpa_casesubtypedetailid: selectedSubTypeDetail[0].dpa_casesubtypedetailid,
            logsendmailid: sendLogRes.dpa_sendemailid,
            dpa_callby: 2,

            contact_firstname: this.formControl["firstname"].value,
            contact_lastname: this.formControl["lastname"].value,
            contact_homeno: this.formControl["dpa_contact_homeno"].value,
            contact_moo: this.formControl["dpa_contact_moo"].value,
            contact_street: this.formControl["dpa_contact_street"].value,
            contact_subdistrictname: this.formControl["dpa_contact_subdistictname"].value,
            contact_districtname: this.formControl["dpa_contact_distictname"].value,
            contact_provincename: this.formControl["dpa_contact_provincname"].value,
            contact_postcodename: this.formControl["dpa_contact_postcodename"].value,
            contact_telephone: this.formControl["telephone1"].value,
            contact_emailaddress: this.formControl["emailaddress1"].value,
          }
          let res: any = await this.apiService.post("crmservice", "sendEmail", req)
  
          if (this.util.isSuccessResponse(res)) {
            this.clear()
            this.util.SuccessDialog("บันทึกข้อมูลสำเร็จ")
          }
          else {
            this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ")
          }
        }
        else {
          this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ")
        }
      }
      else {//if (customerId != null) {
        this.form.controls["customerid"].setValue(null)
        this.form.controls["contactid"].setValue(null)

        let status: any = this.caseStatusList.filter((c: any) => {
          return c.dpa_name.toUpperCase() == "NEW"
        })

        if (status == null || status.length == 0) {
          this.util.ShowWaiting(false)
          this.util.ErrorDialog("ไม่สามารถกำหนดค่าสถานะได้ กรุณาติดต่อเจ้าหน้าที่")
          return
        }

        // let channel: any = this.caseChannelList.filter((c: any) => {
        //   return c.dpa_name.toUpperCase() == "WEBSITE"
        // })

        if (channel == null || channel.length == 0) {
          this.util.ShowWaiting(false)
          this.util.ErrorDialog("ไม่สามารถกำหนดค่าช่องทางได้ กรุณาติดต่อเจ้าหน้าที่")
          return
        }

        this.form.controls["dpa_casestatusid"].setValue(status[0].dpa_casestatusid)
        this.form.controls["dpa_casechannelid"].setValue(channel[0].dpa_casechannelid)
        let caseId = await this.createCase()
        if(caseId == null){
          this.util.ShowWaiting(false)
          this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่")
          return
        }
        // this.form.controls["incidentid"].setValue(caseId)
        else {
        // if (customerId != null && caseId != null) {
          this.clear()
          this.util.SuccessDialog("บันทึกข้อมูลสำเร็จ")
        }
      }
      // else {
      //   this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ")
      // }
      this.util.ShowWaiting(false)
    }
    else {
      this.util.WarningDialog("กรุณากรอกข้อมูลให้ครบ")
    }
  }

  isComplainFilled() {
    if (!this.isComplain) {
      return true
    }
    else {
      return (this.formControl.dpa_idcard.value != null && this.formControl.dpa_idcard.value.trim().length != 0)
        && (this.formControl.dpa_contact_homeno.value != null && this.formControl.dpa_contact_homeno.value.trim().length != 0)
        && (this.formControl.dpa_contact_street.value != null && this.formControl.dpa_contact_street.value.trim().length != 0)
        && (this.formControl.dpa_contact_subdistict.value != null && this.formControl.dpa_contact_subdistict.value.trim().length != 0)
    }
  }

  async createCase() {

    let req = {
      FirstName: this.formControl["firstname"].value,
      LastName: this.formControl["lastname"].value,
      PhoneNo: this.formControl["telephone1"].value,
      Email: this.formControl["emailaddress1"].value,
      UserID: "",
      CaseTypeId: this.formControl["dpa_casetypeid"].value,
      CaseSubTypeId: this.formControl["dpa_casesubtypeid"].value,
      subject: "",
      CaseSubTypeDetailId: this.formControl["dpa_casesubtypedetailid"].value,
      description: this.formControl["description"].value,
      Channel: this.formControl["dpa_casechannelid"].value,
      IdCard: this.formControl["dpa_idcard"].value
    }

    var res: any = await this.apiService.post("crmservice", "caseCaseChatBot", req);
    if (this.util.isSuccessResponse(res)) {
      if (res.Status != null && res.Status == "200") {
        return res.ticketnumber
      } else {
        //this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
        return null
      }
    } else {
      //this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
      return null
    }
  }

  async createContact() {
    let contactid = ""
    await this.apiService.post("crmservice", "contact", this.form.value).then(async (res: any) => {
      if (this.util.isSuccessResponse(res)) {
        if (res.contactid != null && res.contactid != "") {
          contactid = res.contactid
        } else {
          //this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ")
          return null
        }
      } else {
        return null
        //this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ")
      }
    })

    return contactid
  }

  telephoneOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {

      if (charCode == 35 || charCode == 44) {
        return true
      }
      return false;
    }
    return true;
  }

  idCardValidator(control: any) {
    if (control.value && control.value.length == 13) {
      var total = 0;
      var iPID;
      var chk;
      var Validchk;
      iPID = control.value.replace(/-/g, "");
      Validchk = iPID.substr(12, 1);
      var j = 0;
      var pidcut;
      for (var n = 0; n < 12; n++) {
        pidcut = parseInt(iPID.substr(j, 1));
        total = (total + ((pidcut) * (13 - n)));
        j++;
      }

      chk = 11 - (total % 11);

      if (chk == 10) {
        chk = 0;
      } else if (chk == 11) {
        chk = 1;
      }
      if (chk == Validchk) {
        return null;
      } else {
        return { 'invalid IdCard': true };
      }
    }
    else {
      return null;
    }
  }

  mapDataToForm(data: any) {
    Object.keys(data).forEach((key) => {
      if (this.form.controls[key]) {
        this.form.controls[key].setValue(data[key])
      }
      else {
        this.form.addControl(key, new FormControl(data[key]));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/contact-dpa/contact-dpa.component.ts